// A short, pleasant two-note chime via the Web Audio API (no asset needed),
// used to tell the user a background AI Explore answer is ready. Respects a
// persisted mute preference.
const MUTE_KEY = 'inzara.chime.muted';
const VOL_KEY = 'inzara.chime.volume';

export function isChimeMuted() {
  try { return localStorage.getItem(MUTE_KEY) === '1'; } catch { return false; }
}

export function setChimeMuted(muted) {
  try { localStorage.setItem(MUTE_KEY, muted ? '1' : '0'); } catch { /* ignore */ }
}

export function getChimeVolume() {
  try { const v = parseFloat(localStorage.getItem(VOL_KEY)); return Number.isFinite(v) ? v : 0.5; } catch { return 0.5; }
}

export function setChimeVolume(v) {
  try { localStorage.setItem(VOL_KEY, String(Math.max(0, Math.min(1, v)))); } catch { /* ignore */ }
}

export function playChime() {
  const vol = getChimeVolume();
  if (isChimeMuted() || vol <= 0) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    const peak = 0.36 * vol; // 0.18 at the default 50%
    const notes = [[880, 0], [1174.7, 0.13]]; // A5 -> D6
    notes.forEach(([freq, at]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = now + at;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(peak, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(t); osc.stop(t + 0.3);
    });
    setTimeout(() => { try { ctx.close(); } catch { /* ignore */ } }, 800);
  } catch { /* audio not available */ }
}
